<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>{{empresa._id ? `Editar Empresa ${empresa.name}` : 'Nova Empresa'}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar()">Voltar</b-button>
            </div>
          </div>
        </div>

        <div class="element-box">
          <form @submit.prevent="salvar()">
            <div class="form-row">
              <div class="col-4 d-flex justify-content-center">
                <b-card
                  v-if="empresa._id"
                  header="Logomarca da empresa" class="text-center">
                  <b-card-text>
                    <img
                      title="Clique aqui para editar"
                      style="cursor: pointer;"
                      id="imageUploadTmp"
                      @click="$bvModal.show('uploadLogo')"
                      alt="image"
                      width="90px"
                      height="90px"
                      :src="imageUrl"
                      class="rounded-circle img-fluid"
                      :onerror="`this.src='${require('@/assets/img/icon-drachei.svg')}'`"
                    />
                  </b-card-text>
                </b-card>
              </div>
              <div class="col-8">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-6 form-group"
                    :class="{'has-danger': errors.has('razaoSocial')}"
                  >
                    <label for="nome">Nome/Razão Social</label>
                    <input
                      type="text"
                      v-model="empresa.razaoSocial"
                      v-validate="'required'"
                      name="razaoSocial"
                      id="razaoSocial"
                      class="form-control"
                    />
                    <div
                      v-if="errors.has('razaoSocial')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('razaoSocial')}}</div>
                  </div>
                  <div
                    class="col col-sm-12 col-md-6 form-group"
                    :class="{'has-danger': errors.has('nomeFantasia')}"
                  >
                    <label for="nomeFantasia">Nome Fantasia</label>
                    <input
                      type="text"
                      v-model="empresa.name"
                      v-validate="'required'"
                      name="nomeFantasia"
                      id="nomeFantasia"
                      class="form-control"
                    />
                    <div
                      v-if="errors.has('cnpj')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('cnpj')}}</div>
                  </div>
                  <div class="col col-md-12 form-group" :class="{'has-danger': errors.has('cnpj')}">
                    <label for="nmPrestador">CNPJ</label>
                    <input
                      id="cpnj"
                      name="cnpj"
                      type="text"
                      v-mask="'##.###.###/####-##'"
                      v-model="empresa.cnpj"
                      v-validate="'required|cnpj'"
                      class="form-control"
                    />
                    <div
                      v-if="errors.has('cnpj')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('cnpj')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <div class="form-group" :class="{'has-danger': errors.has('telefoneFixo')}">
                  <label for="fixo">Telefone Fixo</label>
                  <input
                    type="tel"
                    name="fixo"
                    id="fixo"
                    v-model="empresa.telefoneFixo"
                    v-validate="'required'"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    class="form-control"
                    aria-describedby="helpId"
                  />
                  <div
                    v-if="errors.has('telefoneFixo')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('telefoneFixo')}}</div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="form-group" :class="{'has-danger': errors.has('celular')}">
                  <label for="celular">Celular</label>
                  <input
                    type="tel"
                    name="celular"
                    id="celular"
                    v-model="empresa.telefoneCelular"
                    v-validate="'required'"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    class="form-control"
                    aria-describedby="helpId"
                  />
                  <div
                    v-if="errors.has('celular')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('celular')}}</div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <div class="form-group" :class="{'has-danger': errors.has('email')}">
                  <label for="email">E-mail</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    v-model="empresa.email"
                    v-validate="'required|email'"
                    class="form-control"
                  />
                  <div
                    v-if="errors.has('email')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('email')}}</div>
                </div>
              </div>

            </div>

            <fieldset>
              <legend>Configuração Clube externo</legend>
              <div class="row">
                <div class="col-md-12">
                    <div class="form-row" :class="{'has-danger': errors.has('clube')}">
                      <label>Nome Clube</label>
                      <input class="form-control" id="clube" name="clube" v-model="empresa.clube">
                      <div
                              v-if="errors.has('clube')"
                              class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('clube')}}</div>
                    </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-row" :class="{'has-danger': errors.has('linkImagemClube')}">
                    <label>Link Imagem</label>
                    <input class="form-control" id="linkImagemClube" name="linkImagemClube"
                           v-model="empresa.linkImagemClube">
                    <div
                            v-if="errors.has('linkImagemClube')"
                            class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('linkImagemClube')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-row" :class="{'has-danger': errors.has('linkClube')}">
                    <label>Link Acesso</label>
                    <input class="form-control" id="linkClube" name="linkClube"
                           v-model="empresa.linkClube">
                    <div
                            v-if="errors.has('linkClube')"
                            class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('linkClube')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-row" :class="{'has-danger': errors.has('senhaPadrao')}">
                    <label>Senha Padrão Clube</label>
                    <input class="form-control" id="senhaPadrao" name="senhaPadrao"
                           v-model="empresa.senhaPadrao">
                    <div
                            v-if="errors.has('senhaPadrao')"
                            class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('senhaPadrao')}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-row" :class="{'has-danger': errors.has('apiKeyClube')}">
                    <label>API Key Clube</label>
                    <input class="form-control" id="apiKeyClube" name="apiKeyClube"
                           v-model="empresa.apiKeyClube">
                    <div
                        v-if="errors.has('apiKeyClube')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('apiKeyClube')}}</div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend>Configuração Plataforma Pagamento</legend>
              <div class="row">
                <div class="col-md-6">
                  <div class="col">
                    <div class="form-row" :class="{'has-danger': errors.has('utilizaPlataformaPagamento')}">
                      <b-form-checkbox switch
                              id="utilizaPlataformaPagamento"
                              v-model="empresa.utilizaPlataformaPagamento"
                              name="utilizaPlataformaPagamento"
                      >
                        Utiliza Plataforma Pagamento
                      </b-form-checkbox>
                      <div
                              v-if="errors.has('utilizaPlataformaPagamento')"
                              class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('utilizaPlataformaPagamento')}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2" v-if="empresa.utilizaPlataformaPagamento">
                <div class="col-md-6">
                  <div class="form-row">
                    <label>Gateway de Pagamento</label>
                    <multiselect
                        v-model="empresa.plataformaPagamento"
                        placeholder="Selecione o Gateway de Pagamento"
                        :showLabels="false"
                        :options="gatewayPagamento"
                    ></multiselect>
                  </div>
                </div>
              </div>
              <div class="row mt-2" v-if="empresa.utilizaPlataformaPagamento && empresa.plataformaPagamento === 'vindi'">
                <div class="col-md-12">
                  <h5>Configuração {{empresa.plataformaPagamento}}</h5>
                </div>
                <div class="col-md-6">
                  <div class="col">
                    <div class="form-row" :class="{'has-danger': errors.has('idVindi')}">
                      <label>Token</label>
                      <input class="form-control" id="idVindi" name="idVindi" v-model="empresa.tokenEmpresaVindi">
                      <div
                          v-if="errors.has('idVindi')"
                          class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('idVindi')}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="empresa.utilizaPlataformaPagamento && empresa.plataformaPagamento === 'Pagar.me'">
                <div class="row mt-2">
                  <div class="col-md-12">
                    <h5>Configuração {{empresa.plataformaPagamento}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <b-form-checkbox switch
                          id="divideTaxaSplit"
                          v-model="empresa.divideTaxaSplit"
                          name="divideTaxaSplit"
                          value="S"
                          unchecked-value="N">
                        Participa do pagamento de Taxas no Split?
                      </b-form-checkbox>
                      <small>Esse campo serve para informar se a empresa participa do pagamento de taxa de transação para Pagar.me</small>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <h5>Dados Bancários</h5>
                    <hr />
                  </div>
                  <div class="col">
                      <div class="form-row">
                        <label>Banco</label>
                        <multiselect
                            v-model="empresa.configSplit.bank"
                            label="Nome_Reduzido"
                            value="Numero_Codigo"
                            track-by="Numero_Codigo"
                            placeholder="Informe o banco"
                            :showLabels="false"
                            :options="bancos"
                        ></multiselect>
                        <small v-if="empresa.configSplit.bank">
                          Código: {{empresa.configSplit.bank.Numero_Codigo}}
                        </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-row">
                      <label>Agência</label>
                      <input class="form-control" id="agencia" name="agencia" v-model="empresa.configSplit.agencia">
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-row">
                      <label>Agência DV</label>
                      <input class="form-control" id="agenciaDV" name="agenciaDV" v-model="empresa.configSplit.agenciaDV">
                    </div>
                  </div>
              </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <label>Tipo de Conta</label>
                      <multiselect
                          v-model="empresa.configSplit.tipoConta"
                          label="value"
                          value="id"
                          track-by="id"
                          placeholder="Informe o tipo de conta"
                          :showLabels="false"
                          :options="tipoContas"
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <div class="row">
                <div class="col-md-4">
                  <div class="form-row">
                    <label>Conta</label>
                    <input class="form-control" id="conta" name="conta" v-model="empresa.configSplit.conta">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-row">
                    <label>Conta DV</label>
                    <input class="form-control" id="contaDV" name="contaDV" v-model="empresa.configSplit.contaDV">
                  </div>
                </div>
              </div>

                <fieldset>
                  <legend>Configuração de Transferência</legend>

                  <div class="row">
                    <div class="col-md-4">
                      <b-form-checkbox switch
                                       id="utilizaTransferencia"
                                       v-model="empresa.configSplit.utilizaTransferencia"
                                       name="utilizaTransferencia"
                      >
                        Habilitar transferência automática
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="row" v-if="empresa.configSplit.utilizaTransferencia">
                    <div class="col-md-4">
                      <div class="form-row">
                        <label>Tipo de intervalo</label>
                        <multiselect
                            v-model="empresa.configSplit.tipoIntervalo"
                            placeholder="Selecione o tipo de intervalo"
                            :showLabels="false" label="value" code="id"
                            :options="tiposIntervalo"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="col-md-4" v-if="empresa.configSplit.tipoIntervalo &&
                        empresa.configSplit.tipoIntervalo.id !== 'daily'">
                      <div class="form-row">
                        <label>Dia de transferência</label>
                        <multiselect
                            v-model="empresa.configSplit.diaTransferencia"
                            placeholder="Selecione o Dia de transferência"
                            :showLabels="false" label="value" code="id"
                            :options="diaSemanaPorTipoIntervalo"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </template>
            </fieldset>

            <fieldset>
              <legend>Configuração</legend>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-row" :class="{'has-danger': errors.has('numeracaoInicialCartao')}">
                    <label>Numeração Inicial Cartão</label>
                    <input type="tel" class="form-control"
                      id="numeracaoInicialCartao" name="numeracaoInicialCartao"
                      ref="numeracaoInicialCartao"
                      min="0" max="9999"
                      v-model="empresa.numeracaoInicialCartao"
                      v-validate="'required'">
                    <div
                      v-if="errors.has('numeracaoInicialCartao')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('numeracaoInicialCartao')}}</div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row" :class="{'has-danger': errors.has('pagarComissao')}">
                    <b-form-checkbox
                        id="pagarComissao"
                        v-model="empresa.pagarComissao"
                        name="pagarComissao"
                        value="S"
                        unchecked-value="N">
                        <br/>
                        Realiza pagamento de comissão para vendedor
                    </b-form-checkbox>
                    <div
                      v-if="errors.has('pagarComissao')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('pagarComissao')}}</div>
                  </div>
                </div>

              </div>
            </fieldset>

            <fieldset>
              <legend>Endereço</legend>

              <div class="form-row">
                    <div class="col form-group col-md-2">
                        <label for="cep">CEP</label>
                        <input @keyup="buscaCEP()" type="tel"
                          v-mask="'#####-###'" v-model="empresa.cep"
                          name="cep" id="cep" class="form-control">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <label for="logradouro">Logradouro</label>
                        <input type="text" v-model="empresa.endereco"
                          name="logradouro" id="logradouro" class="form-control">
                    </div>
                    <div class="col form-group col-md-2">
                        <label for="numero">Número</label>
                        <input type="text" v-model="empresa.numero"
                          name="numero" id="numero" class="form-control">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <label for="bairro">Bairro</label>
                        <input type="text" v-model="empresa.bairro"
                          name="bairro" id="bairro" class="form-control">
                    </div>
                    <div class="col form-group">
                        <label for="cidade">Cidade</label>
                        <input type="text" v-model="empresa.cidade"
                          name="cidade" id="cidade" class="form-control">
                    </div>
                    <div class="col form-group col-md-2">
                        <label for="uf">UF</label>
                        <select name="uf"
                          v-model="empresa.uf" id="uf" class="form-control">
                            <option value="">Selecione</option>
                            <option v-for="uf in ufs" :key="uf" :value="uf" v-text="uf"></option>
                        </select>
                    </div>
                    <div class="col form-group">
                        <label for="complemento">Complemento</label>
                        <input type="text"
                          v-model="empresa.complemento" name="complemento" id="complemento" class="form-control">
                    </div>
                </div>
            </fieldset>

            <div class="row">
              <div class="col center-block">
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <b-modal id="uploadLogo" title="Logo da empresa" hide-footer>
      <form @submit.prevent="uploadLogo" autocomplete="off">
        <div class="row">
          <div class="col-md-12">
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                @change="processFile($event)"
                id="validatedCustomFile"
                required
              />
              <label class="custom-file-label" for="validatedCustomFile">Informe o arquivo...</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center m-3">
            <img
              v-if="imagePreview"
              id="imageUploadTmp"
              alt="image"
              width="90px"
              height="90px"
              :src="imagePreview"
              class="rounded-circle img-fluid"
            />
          </div>
        </div>
        <div class="row">
          <div class="col text-right mb-2">
            <div class="btn-login">
              <button type="button" class="btn btn-outline-secondary" @click="$bvModal.hide('uploadLogo')">Cancelar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import { Validator } from "vee-validate";
import Multiselect from 'vue-multiselect';
import utils from "@/utils";
import {bancos} from '@/db/bancos';

export default {
  components: {
    Multiselect
  },
  computed: {
    diaSemanaPorTipoIntervalo() {
      if (this.empresa.configSplit.tipoIntervalo &&
          this.empresa.configSplit.tipoIntervalo.id === 'weekly') {
        return this.diasSemanaTransferencia;
      } else if (this.empresa.configSplit.tipoIntervalo &&
          this.empresa.configSplit.tipoIntervalo.id === 'monthly') {
        return Array.from(Array(30).keys()).map((v) => ({id: (v+1), value: (v+1)}));
      } else {
        return [];
      }
    }

  },
  async created() {
    Validator.extend("cnpj", {
      getMessage: () => "CNPJ inválido",
      validate: value => {
        return !!utils.TestaCNPJ(value);
      }
    });

    let id = this.$route.query.id;
    if (id) {
      const response = await axios.get(`/api/juridica/${id}`);
      this.empresa = response.data;
    }
  },
  data() {
    return {
      bancos: bancos,
      tipoContas: [{id: 'conta_corrente', value: 'Conta Corrente'}, {id: 'conta_poupanca', value: 'Conta Poupança'},
        {id: 'conta_corrente_conjunta', value: 'Conta Corrente Conjunta'},
        {id: 'conta_poupanca_conjunta', value: 'Conta Poupança Conjunta'}],
      gatewayPagamento: ['vindi', 'Pagar.me'],
      tiposIntervalo: [{id: 'daily', value: 'Diario'}, {id: 'weekly', value: 'Semanal'}, {id: 'monthly', value: 'Mensal'}],
      diasSemanaTransferencia: [{id: 1, value: 'Segunda-feira'}, {id: 2, value: 'Terça-feira'}, {id: 3, value: 'Quarta-feira'},
        {id: 4, value: 'Quinta-feira'}, {id: 5, value: 'Sexta-feira'}],
      empresa: {
        cidade: null,
        uf: null,
        bairro: null,
        endereco: null,
        complemento: null,
        utilizaPlataformaPagamento: false,
        configSplit: {
          tipoIntervalo: null,
          diaTransferencia: null,
          utilizaTransferencia: false,
          bank: {},
          agencia: null,
          agencia_dv: null,
          conta: null,
          conta_dv: null,
        }
      },
      imageUrl: "",
      imagePreview: null,
      ufs:[
        "AC",
        "AL",
        "AM",
        "AP",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RO",
        "RS",
        "RR",
        "SC",
        "SE",
        "SP",
        "TO"
      ],
      plataformasPagamento: [{key: 'none', value: 'Nenhuma'}, {key: 'vindi', value: 'vindi'}, {key: 'iugu', value: 'iugu'}]
    };
  },
  methods: {
    editaDiasTransferencia() {
      this.empresa.configSplit.diaTransferencia = null;
    },
    voltar() {
      this.$router.push({ name: "Empresa" });
    },
    async salvar() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.empresa._id) {
            await axios.put(`/api/juridica/${this.empresa._id}`, this.empresa);
          } else {
            const responseCartao = await axios.get(`/api/cartao?numeroCartao__regex=^${this.empresa.numeracaoInicialCartao}`)
            const resultCartao = responseCartao.data;
            if (resultCartao.length > 0) {
              await this.$bvModal.msgBoxOk(`Numeração inicial Informada '${this.empresa.numeracaoInicialCartao}' em uso!`, {
                title: 'Alerta'
              });

              const field = this.$validator.fields.find({ name: 'numeracaoInicialCartao' });

              this.$validator.errors.add({
                id: field.id,
                field: 'numeracaoInicialCartao',
                msg: 'Numeração em uso',
                scope: this.$options.scope,
              });

              field.setFlags({
                invalid: true,
                valid: false,
                validated: true,
              });

              return false;
            } else {
              this.empresa.status = 'Desabilitado'
              const responseEmpresa = await axios.post('/api/juridica', this.empresa);
              this.empresa = responseEmpresa.data;
            }

          }

          if (!this.$store.getters.empresa) {
            this.$store.dispatch('setEmpresa', this.empresa);
          } else if (this.$store.getters.empresa._id === this.empresa._id) {
            this.$store.dispatch('setEmpresa', this.empresa);
          }

          this.$router.push({name: 'Empresa'})
        }
      });
    },
    async uploadLogo(){
      try {
        const payload = new FormData();
        payload.append('file', this.logo);
        payload.append('idJuridica', this.empresa._id);
        await axios.post('/api/juridicaLogo/upload/', payload);
        this.$bvModal.hide('uploadLogo');
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    processFile(event){
      this.logo = event.target.files[0]
      if (this.logo) {
        let file = new FileReader()
        const _self = this
        file.onload = (e) => {
          _self.imagePreview = e.target.result
        }
        file.readAsDataURL(this.logo)
      }
    },
    buscaCEP () {
      if (this.empresa.cep) {
        this.empresa.cep = this.empresa.cep.replace(/[-]/g, '')
        if (this.empresa.cep.length === 8) {
          axios.get(`https://viacep.com.br/ws/${this.empresa.cep}/json/`)
            .then((result) => {
              let endereco = result.data
              this.empresa.cidade = endereco.localidade
              this.empresa.bairro = endereco.bairro
              this.empresa.endereco = endereco.logradouro
              this.empresa.uf = endereco.uf
              this.empresa.complemento = endereco.complemento
            })
        }
      }
    }
  }
};
</script>
